import { render, staticRenderFns } from "./QualificationTable.vue?vue&type=template&id=495d9d26&"
import script from "./QualificationTable.vue?vue&type=script&lang=js&"
export * from "./QualificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports